module.exports = "/assets/36b54ad46c8e4b226aee08ce762653cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JK.png
// module id = 1513
// module chunks = 0